import React from "react";
import PropTypes from "prop-types";
import FeedCardHeader from "./FeedCardHeader";
import FeedCardHeaderTitle from "./FeedCardHeaderTitle";
import FeedCardHeaderIcon from "./FeedCardHeaderIcon";
import FeedCardHeaderDate from "./FeedCardHeaderDate";
import FeedCardBadge from "./FeedCardBadge";

export const FeedCard = ({
  id = `${Date.now()}`,
  children = null,
  badgeClassName = "",
  badgeContent = null,
  className = ""
}) => {
  const badgeWrapperClass = badgeContent ? "card--badge" : "";

  return (
    <div
      className={`panel panel-default card--feed ${className} ${badgeWrapperClass}`}
      id={`feedcard-${id}`}
    >
      {badgeContent ? (
        <FeedCardBadge className={badgeClassName}>{badgeContent}</FeedCardBadge>
      ) : null}
      {children}
    </div>
  );
};

FeedCard.propTypes = {
  id: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  badgeContent: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string
  ]),
  badgeClassName: PropTypes.string,
  className: PropTypes.string
};

export default Object.assign(FeedCard, {
  Header: FeedCardHeader,
  Title: FeedCardHeaderTitle,
  Icon: FeedCardHeaderIcon,
  Date: FeedCardHeaderDate
});
